import {InvoiceResponse} from "@/types/service-response";

export default class TransactionInvoice {
  private constructor(
      readonly amountPayed: number,
      readonly invoice: {
          readonly  amountFromDept: number,
          readonly  amountFromWallet: number,
          readonly  boarderBankIdentificationCode: number,
          readonly  constantSymbol: string,
          readonly  currency: string,
          readonly customer: {
              id: number,
              name: string
          },
          readonly dueDate: string,
          readonly iban: string,
          readonly id: string,
          readonly issueDate: string,
          readonly name: string,
          readonly periodEnd: string,
          readonly periodKind: string,
          readonly periodStart: string,
          readonly priceItemSum: number,
          readonly priceTotal: number,
          readonly specificSymbol: string,
      },
      readonly invoiceKind: string
  ) {}


  static createFromResponse(responseData: InvoiceResponse[]): TransactionInvoice[] {
      return responseData.map((item: InvoiceResponse) => {
        return new TransactionInvoice(
            item.amountPayed,
            item.invoice,
            item.invoiceKind
        )
      })
  }
}